import { NavLink } from "react-router-dom";

import iconProdejci from "../images/buttons/prodejci.png";
import iconUzivatele from "../images/buttons/uzivatele.png";
import iconSlevy from "../images/buttons/slevaikona.png";
import iconImportCen from "../images/buttons/cenikproduktu.png";
import iconNastaveni from "../images/buttons/settings.png";
import iconPodpora from "../images/buttons/support.png";
import iconImport from "../images/buttons/importexcel.png";
import UserInfo from "./UserInfo";

import "./navigation.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { checkAdditionalRole, checkCrud } from "../helpers/userRolesHelper";
import TopNavigationItem from "./TopNavigationItem";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";

interface Props {
  isLeftMenuHidden: boolean;
}

const TopNavigation = (props: Props) => {
  const { t } = useTranslation();
  const [canSeller, setCanSeller] = useState(false);
  const [canUser, setCanUser] = useState(false);
  const [canDiscount, setCanDiscount] = useState(false);
  const [canImportPrices, setCanImportPrices] = useState(false);
  const [canManageReceipts, setCanManageReceipts] = useState(false);
  const [canCenik, setCanCenik] = useState(false);

  const userInfo = useSelector((state: any) => state.userInfo);

  useEffect(() => {
    if (userInfo) {
   
      setCanSeller(checkCrud('seller', 'read', userInfo));
      setCanUser(checkCrud('user', 'read', userInfo));
      setCanDiscount(checkCrud('discount', 'read', userInfo));
      setCanManageReceipts(checkCrud('receipt', 'admin', userInfo));
      setCanImportPrices(checkAdditionalRole('priceList', userInfo));
      setCanCenik(checkAdditionalRole('cenik', userInfo));
    }
  }, [userInfo])
  return (
    <nav
      id="topNavigationElement"
      style={{paddingTop:'0',paddingBottom:'0'}}
      className={props.isLeftMenuHidden ? "navbar navbar-light navbar-expand-md scrolling-navbar flexible-navbar wide" : " navbar navbar-light navbar-expand-md scrolling-navbar flexible-navbar narrow"}
      role="navigation"
    >
      <button type="button" className="navbar-toggler">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse">
        <ul style={{ paddingLeft: "10px" }} className="navbar-nav mr-auto">
          <li className="nav-item">
            <TopNavigationItem
              label={t('Sellers.Label')}
              icon={iconProdejci}
              link={'/prodejci'}
              hasAccess={canSeller}
            />
            {/* <NavLink to="/prodejci" activeClassName="activeClass">
              <a
                className="nav-link Ripple-parent"
                href="/previews/free-templates/react-admin-dashboard/"
              >
                <img src={iconProdejci} />
                Prodejci
                <div
                  className="Ripple "
                  style={{ top: 0, left: 0, width: 0, height: 0 }}
                ></div>
              </a>
            </NavLink> */}
          </li>
          <li className="nav-item">
            <TopNavigationItem
              label={t('Users.Label')}
              icon={iconUzivatele}
              link={'/uzivatele'}
              hasAccess={canUser}
            />
            {/* <NavLink to="/uzivatele" activeClassName="activeClass">
              <a
                rel="noopener noreferrer"
                className="nav-link Ripple-parent"
                href="https://mdbootstrap.com/react/5-min-quick-start/"
                target="_blank"
              >
                <img src={iconUzivatele} />
                Uživatelé
              </a>
            </NavLink> */}
          </li>
          <li className="nav-item">
            <TopNavigationItem
              label={t('Discounts.Label')}
              icon={iconSlevy}
              link={'/slevy'}
              hasAccess={canDiscount}
            />
            {/* <NavLink to="/slevy" activeClassName="activeClass">
              <a
                rel="noopener noreferrer"
                className="nav-link Ripple-parent"
                href="https://mdbootstrap.com/react/5-min-quick-start/"
                target="_blank"
              >
                <img src={iconSlevy} />
                Slevy
              </a>
            </NavLink> */}
          </li>
          <TopNavigationItem
            label={t('ImportPrices.Label')}
            icon={iconImportCen}
            link={'/importCen'}
            hasAccess={canImportPrices}
          />
          {/* <li className="nav-item">
            <NavLink to="/importCen" activeClassName="activeClass">
              <a
                rel="noopener noreferrer"
                className="nav-link Ripple-parent"
                href="https://mdbootstrap.com/react/5-min-quick-start/"
                target="_blank"
              >
                <img src={iconImportCen} />
                {t('ImportPrices.Label')}
              </a>
            </NavLink>
          </li> */}
          {/*
          <li className="nav-item">
            <NavLink to="/nastaveni" activeClassName="activeClass">
              <a
                rel="noopener noreferrer"
                className="nav-link Ripple-parent"
                href="#"
                target="_blank"
              >
                <img src={iconNastaveni} />
                {t('Settings.Label')}
              </a>
            </NavLink>
          </li>
          */}
          <li className="nav-item">
            <NavLink to="/podpora" activeClassName="activeClass">
              <a
                rel="noopener noreferrer"
                className="nav-link Ripple-parent"
                href="#"
                target="_blank"
              >
                <img src={iconPodpora} />
                {t('Support.Label')}
              </a>
            </NavLink>
          </li>

          {canManageReceipts &&
            <li className="nav-item">
              <NavLink to="/importReceptur" activeClassName="activeClass">
                <a
                  rel="noopener noreferrer"
                  className="nav-link Ripple-parent"
                  href="#"
                  target="_blank"
                >
                  <img src={iconImport} />
                  {t('ImportReceipts.Label')}
                </a>
              </NavLink>
            </li>


          }

          { canManageReceipts &&
            <li className="nav-item">
              <NavLink to="/exportReceptur" activeClassName="activeClass">
                <a
                  rel="noopener noreferrer"
                  className="nav-link Ripple-parent"
                  href="#"
                  target="_blank"
                >
                  <img src={iconImport} />
                  {t('ExportReceipts.Label')}
                </a>
              </NavLink>
            </li>
          }

          {canCenik &&
            <li className="nav-item">
              <NavLink to="/cenik" activeClassName="activeClass">
                <a
                  rel="noopener noreferrer"
                  className="nav-link Ripple-parent"
                  href="#"
                  target="_blank"
                >
                  <img src={iconImport} />
                  {t('PriceList.Label')}
                </a>
              </NavLink>
            </li>
          }
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <UserInfo />
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item" style={{zIndex:1111}}>
            <LanguageSelector />
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default TopNavigation;
